import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagination, Table, TableData, TableDataTypes } from 'src/app/shared/types';
import { CaptainRedeemService } from 'src/app/captain-redeem-service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-captain-dues-transactions',
  templateUrl: './captain-dues-transactions.component.html',
  styleUrls: ['./captain-dues-transactions.component.css']
})
export class CaptainDuesTransactions implements OnInit {
  @Input() captainId: string;
  @Input() captainDetailsToggleableHeaders: string[];
  @Output() toggleHeaders: EventEmitter<any> = new EventEmitter();

  captainDuesTransactions: Table;

  dataLoaded = false;
  perPage = 10;
  firstElement = ""
  lastElement = ""
  next = ""
  prev = ""
  statusToFetch = ["paid", "pending"];

  constructor(private redeemService: CaptainRedeemService) { }

  ngOnInit() {
    this.declareTable();
  }

  declareTable() {
    this.captainDuesTransactions = new Table({
      toggleableHeaders: this.captainDetailsToggleableHeaders,
      headers: {
        CreatedAt: 'Created at',
        Type: 'Type/Reason',
        Subtype: 'Subtype',
        Status: 'Status',
        Amount: 'Amount',
        OrderId: 'Order id',
        PaidOn: 'Paid on'
      },
      pagination: new Pagination(0, this.perPage, 30, [10, 15, 20], 0, true),
      selectedHeader: 13,
      defaultError: 'No dues transactions found',
      onRefresh: () => {
        this.captainDuesTransactions = null;
        this.ngOnInit();
      },
      data: []
    });
    this.getDuesTransactions();
  }

  getPaymentTimestamp(transaction) {
    let paymentProgress = transaction.paymentProgress
    if (paymentProgress && paymentProgress[paymentProgress.length-1] && paymentProgress[paymentProgress.length-1].paymentTimestamp) {
      let paymentTimestamp = paymentProgress[paymentProgress.length-1].paymentTimestamp
      return this.toDateTimeFormatYYYYMMDDHHMMSS(paymentTimestamp);
    } else {
      return '-'
    }
  }

  async getDuesTransactions() {
    const data = {
      "statusToFetch": this.statusToFetch,
      "count": this.perPage
    }
    this.dataLoaded = false;
    this.redeemService.getCaptainDuesTransactions(this.captainId, data, this.perPage, this.next, this.prev)
      .then((response) => {

        const transactionArray = response && response.data;
        if (!transactionArray.length) {
          this.dataLoaded = true;
          this.captainDuesTransactions.data = []
        }
        this.firstElement = transactionArray[0].id
        this.lastElement = transactionArray[transactionArray.length - 1].id;

        this.captainDuesTransactions.data = transactionArray.map((transaction) => {
          return {
            CreatedAt: this.createTableData(this.toDateTimeFormatYYYYMMDDHHMMSS(transaction.createdAt)),
            Type: this.createTableData(transaction.transactionType),
            Subtype: this.createTableData(transaction.subType),
            Status: this.createTableData(transaction.status),
            Amount: this.createTableData(Math.abs(transaction.amount).toString()),
            OrderId: this.createTableData(transaction.metaData.orderUniqueId),
            PaidOn: this.createTableData(this.getPaymentTimestamp(transaction))
          };

        });
        this.dataLoaded = true;
      }).catch(err => {
        console.log(err);
        this.dataLoaded = true;
      });
  }


  toDateTimeFormatYYYYMMDDHHMMSS(time): string {
    return `${new Date(time).toLocaleDateString()} ${new Date(time).toLocaleTimeString()}`
  }

  createTableData(value: string, className?: string, type?: TableDataTypes, flag = false, hoverData = null) {
    return new TableData({
      data: value,
      type: type ? type : TableDataTypes.DATA,
      flag: flag,
      hoverData: hoverData,
      className: className ? className + ' cursor-pointer' : 'cursor-pointer whiteSpacePre',
    });
  }

  changeInHeader(header: string) {
    this.toggleHeaders.emit(header);
  }

  onPaginationChange(event: { perPage: number, previousPageIndex: number, pageNo: number }) {
    if (event.pageNo < event.previousPageIndex) {
      this.next = ""
      this.prev = this.firstElement
    } else if (event.pageNo > event.previousPageIndex) {
      this.prev = ""
      this.next = this.lastElement
    }
    this.perPage = event.perPage
    this.getDuesTransactions();
  }
}

